import React from "react";

const SelectField = ({ label, id, name, value, onChange, options = [], className, state, disabled = "", placeholder = "Select an option" }) => {

    const formatOptions = () => {
    return options.map((option, idx) => {
      // If option is a string, convert to object format
      if (typeof option === 'string') {
        return { value: option, label: option };
      }
      // If option is already an object, use it as is
      return option;
    });
  };

  const formattedOptions = formatOptions();

  return (
    <div className={className}>
      <label htmlFor={id} className="block text-base  text-navy-700 dark:text-white ml-3 font-bold">
        {label}
      </label>
      <select
        disabled={disabled}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 dark:bg-white/5 p-3 text-sm outline-none ${
          disabled === true
            ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
            : state === "error"
            ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
            : state === "success"
            ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
            : "border-gray-200 dark:!border-white/10 dark:text-white dark:bg-white/5"
        }`}
      >
        <option value="" disabled className="dark:bg-gray-900 dark:text-white">{placeholder}</option>
        {formattedOptions.map((option, idx) => (
          <option key={idx} value={option.value} className="dark:bg-gray-900 dark:text-white">{option.label}</option>
        ))}
      </select>
    </div>
  );
};

export default SelectField;